<template>
  <v-dialog v-model="dialog" width="800">
    <v-card>
      <div class="py-2 px-4">
        <VBtn
          absolute
          icon
          right
          style="right: 20px; top: 20px"
          class="mt-0 pb-0"
          @click="close"
        >
          <VIcon>mdi-close</VIcon>
        </VBtn>
        <v-card-title>{{ $t("name") }}: {{ item.name }}</v-card-title>
        <v-card-text>{{ $t("count") }}: {{ item.count }}</v-card-text>
        <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
          <form @submit.prevent="handleSubmit(handlePost)">
            <div class="d-flex px-4 pb-10 justify-space-between align-center">
              <CustomInputText
                only="number"
                :rules="{
                  required: true,
                  max_value: item.count,
                }"
                v-model="formData.count"
                class="user_input no-margin pr-3"
              />
              <v-btn type="submit" color="error">{{ $t("delete") }}</v-btn>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      item: {},
      formData: {
        departmentId: "",
        productId: "",
        count: 0,
      },
    };
  },
  props: {
    departmentData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    clear() {
      this.formData = {
        departmentId: "",
        productId: "",
        count: 0,
      };
      this.$refs.formObs.reset();
    },
    open(data) {
      this.dialog = true;
      this.item = data;
    },
    close() {
      this.dialog = false;
    },
    async handlePost() {
      this.showLoading();
      this.formData.departmentId = this.departmentData.id;
      this.formData.productId = this.item.productId;
      try {
        await this.$http.post(
          "office-product/take-from-department",
          (this.formData = {
            departmentId: this.departmentData.id,
            productId: this.item.productId,
            count: Number(this.formData.count),
          })
        );
        this.$emit("saved");
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.close();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
};
</script>
